import { AudioSoundEvent, Exercise, Phase, ScheduleEntryColourCode, SessionSequence } from '../../../entities';
import { ISessionSequenceStrategy } from '../isessionsequencestrategy';
import { transitionBeepAudioTipFileName } from './homeSharedSequenceEntries';

export class HomePauseAtHalfwayBreak implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
  ): SessionSequence[] {
    return [{
      durationInMilliseconds: 2,
      sequence: [{
        durationInMilliseconds: 2,
        videoFile: '0TRANSITION_TO_BREAK',
        exerciseVersion: exercise._rev,
        displayName: '',
        displayBurnOrBuildIcon: false,
        progressColourCode: ScheduleEntryColourCode.Rest,
        progressText: '',
        showProcessedMetrics: false,
        showCalculatedMetrics: true,
        tips: [],
        audioTipStartDelay: 0,
        audioTipFileName: transitionBeepAudioTipFileName,
        audioTips: [{
          fileName: transitionBeepAudioTipFileName, delay: 0,
        }],
        zone,
        quarter,
        phase: Phase.ChangeZone,
      }],
    },
    {
      durationInMilliseconds: 20,
      sequence: [{
        durationInMilliseconds: 20,
        videoFile: exercise.uniqueReferenceNumber,
        exerciseVersion: exercise._rev,
        displayName: exercise.name,
        displayBurnOrBuildIcon: true,
        progressColourCode: ScheduleEntryColourCode.Rest,
        progressText: 'Break for {seconds}',
        showProcessedMetrics: false,
        showCalculatedMetrics: true,
        audioSoundEvent: AudioSoundEvent.startOfRestPeriod,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.Rest,
        zone,
        showLargeViewInGroupWorkout: false,
        videoHasAudio: true,
        playVideoFromCurrentSequenceDuration: true,
      }],
    },
  ];
  }
}
